exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".autocomplete {\n    position: relative;\n    width: 100%;\n    margin-bottom: 10px;\n}\n.autocomplete .choices {\n    position: absolute;\n    width: 100%;\n    height: 150px;\n    overflow: auto;\n    overflow-y: scroll;\n    top: 33px;\n    left: 0;\n    z-index: 1201;\n    background: #ffffff;\n    border: 1px solid #c1c1c1;\n}\n\n.autocomplete .choices .choice {\n    padding: 5px;\n    cursor: pointer;\n    border-bottom: 1px solid #c1c1c1;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/accounts-receivable/public/assets/css/autocomplete.css
// module id = 579
// module chunks = 0